import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SipService } from '../services/sip.service';
import { UserPresenceState } from '../enums/user-presence-state.enum';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { EveUserStatusService } from '../services/eve-user-status.service';
import { Status } from 'src/generated/eveportal-api/graphql';
import { TokenService } from '../services/token.service';
import { Router } from '@angular/router';

const presenceToStatusMap: Record<UserPresenceState, Status> = {
  [UserPresenceState.Available]: Status.Available,
  [UserPresenceState.Busy]: Status.Busy,
  [UserPresenceState.Holiday]: Status.Holiday,
  [UserPresenceState.Lunch]: Status.Lunch,
  [UserPresenceState.Meeting]: Status.Meeting,
  [UserPresenceState.OutOfOffice]: Status.OutOfOffice,
};

export function toStatus(presence: UserPresenceState): Status {
  return presenceToStatusMap[presence];
}

export interface UserProfileData {
  eveUserId: number;
  firstName: string;
  surname: string;
  username: string;
  phoneNumber: number | null;
  internalNumber: number | null;
  avatarUrl: string;
  presenceClass$: Observable<string>; // Changed to Observable<string>
  currentPresence: UserPresenceState; // Changed to enum type
  availablePresenceStates: { key: UserPresenceState; value: string }[]; // Changed to key-value pairs
}

@Component({
  selector: 'app-user-profile-dialog',
  templateUrl: './user-profile-dialog.component.html',
  styleUrls: ['./user-profile-dialog.component.css'],
})
export class UserProfileDialogComponent implements OnInit, OnDestroy {

  selectedPresence: UserPresenceState;
  private destroySubject = new Subject<void>();
  constructor(
    public dialogRef: MatDialogRef<UserProfileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UserProfileData,
    private sipService: SipService,
    private userStatusService: EveUserStatusService,
    private router: Router,
    private tokenService: TokenService
  ) {
     this.selectedPresence = data.currentPresence;
  }
  ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }

  ngOnInit() {}

  onPresenceChange(newPresence: UserPresenceState): void {
    // Convert directly using the enum key name
    const status = toStatus(newPresence);

    // Optionally update presence immediately
    this.sipService.setUserPresenceState(newPresence);
    this.userStatusService.updateUserStatus(this.data.eveUserId, status)
    .pipe(takeUntil(this.destroySubject))
    .subscribe({next: () => {
      console.log('User status updated successfully');
    }});
  }

  onLogoutClick(): void {

     // Clear all SIP calls before logging out
    this.sipService.clearActiveCalls();

    // Clear authentication tokens
    this.tokenService.clearAllTokens();

    // Navigate to login page
    this.router.navigate(['/login']);

    this.dialogRef.close({ action: 'logout' });
  }

  onClose(): void {
    this.dialogRef.close({ action: 'close' });
  }
}
